import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
const EmailSubscribeBladeTypeValues = ["emailSubscribe"];
export const EmailSubscribeBladeTypesSchema = z.enum(EmailSubscribeBladeTypeValues);
export const EmailSubscribeBladeTypes = EmailSubscribeBladeTypesSchema.enum;
export const EmailSubscribeBladeSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    backdrop: BackdropSchema.optional(),
    emailCapture: z.object({
        collector: z.object({
            type: z.string(),
            publicationListName: z.string(),
            externalKey: z.string().optional(),
        }),
        minimumAge: z.number(),
        emailLabel: z.string(),
        emailPlaceholder: z.string().optional(),
        emailErrorText: z.string(),
        dobPlaceholder: z.string().optional(),
        dobLabel: z.string(),
        dobErrorText: z.string(),
        consentText: z.string(),
        consentErrorText: z.string(),
        submitText: z.string(),
        successText: z.string(),
    }),
});
export const EmailSubscribeBladesContractSchema = EmailSubscribeBladeSchema.extend({
    type: EmailSubscribeBladeTypesSchema,
});
export const EmailSubscribeContractSchema = EmailSubscribeBladesContractSchema.extend({
    type: z.literal(EmailSubscribeBladeTypes.emailSubscribe),
});
//# sourceMappingURL=index.js.map